import { useEffect } from "react";

/* EVERY DIALOG FITS THE PART OF THE SCREEN THE KEYBOARD LEAVES (his phone and tablet, 22 Oct):
 * "Creating a part from the VEHICLE screen won't let me scroll up or down."
 * The tag box takes focus, the on-screen keyboard covers the bottom of a SHORT dialog (Create included),
 * the dialog has nothing of its own to scroll, and the page behind is locked — so nothing moves.
 * This writes the visible height and top (`--vvh`, `--vvt`, `--vvb`) so dialogs, confirmations, side
 * panels and floor overlays size themselves to what is really on screen and scroll inside it.
 * The focused field is kept in view as the keyboard opens. Mounted once, in App. */
const FIELD = "input, textarea, select, [contenteditable='true']";
const LAYER = "[role='dialog'], [role='alertdialog'], [data-vv-layer]";

export const VisibleScreen = () => {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const root = document.documentElement.style;
    let raf = 0;
    let lastH = 0;
    const apply = () => {
      raf = 0;
      const h = Math.round(vv.height);
      const top = Math.round(vv.offsetTop);
      root.setProperty("--vvh", `${h}px`);
      root.setProperty("--vvt", `${top}px`);
      root.setProperty("--vvb", `${Math.max(0, Math.round(window.innerHeight - top - h))}px`);
      const el = document.activeElement;
      if (h < lastH && el?.matches?.(FIELD) && el.closest(LAYER)) el.scrollIntoView({ block: "nearest" });
      lastH = h;
    };
    const later = () => { if (!raf) raf = requestAnimationFrame(apply); };
    apply();
    vv.addEventListener("resize", later);
    vv.addEventListener("scroll", later);
    return () => {
      vv.removeEventListener("resize", later);
      vv.removeEventListener("scroll", later);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
  return null;
};
